import { Fragment, useCallback, useEffect, useState } from "react";
import { useParams } from "react-router";
import axios from "axios";
import { slugSplitter } from "../../../utils/slugManager";
import { FeatureCard } from "../components/featureCard";
import config from "../../../configuration/config";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import { EmptyState } from "../../../components/EmptyState";

export function VehicleFeaturePage() {
    const { t: trans, i18n } = useTranslation(["car", "vehicales"]);
    const { slug, group, year, brand } = useParams();
    const [features, setFeatures] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    let lang = (i18n.language || 'ar');

    const callback = useCallback(async () => {
        setIsLoading(true);
        try {
            setFeatures([]);
            const response = await axios.request({
                baseURL: config.controllURL,
                url: lang + "/api/VehicleFeature/" + slugSplitter(brand) + "/" + group + "/" + year + "/feature",
                method: "get",
            });

            setFeatures(response.data || []);

        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    }, [group, year, brand, lang]);

    useEffect(() => {
        callback();
    }, [callback]);

    return (
        <Fragment>
            <div className="container mb-32">
                <div className="nice-row grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {isLoading ? (
                        [1, 2, 3, 4, 5, 6].map((i) => (
                            <div key={i} className="p-4 border border-gray-100 rounded-2xl">
                                <Skeleton height={200} borderRadius={12} className="mb-4" />
                                <Skeleton width="70%" height={24} className="mb-2" />
                                <Skeleton width="40%" height={16} />
                            </div>
                        ))
                    ) : features?.length > 0 ? (
                        features.map((feature, index) => (
                            <FeatureCard
                                key={index}
                                title={feature.title}
                                description={feature.desc}
                                image={feature.image}
                            />
                        ))
                    ) : (
                        <div className="col-span-full">
                            <EmptyState message={trans("vehicales:no-features-data") || "No features found for this vehicle"} />
                        </div>
                    )}
                </div>
            </div>
        </Fragment>
    );
}